import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loader from '../loader/Loader';

function Button({
  disabled,
  onClick,
  className,
  loading,
  text,
  loaderColor,
  textColor,
  borderColor,
  icon
}) {
  const borderClassNames = borderColor ? `border ${borderColor}` : '';
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => {
        if (!loading && onClick) {
          onClick();
        }
      }}
      className={`${className} ${borderClassNames} inline-flex h-11 items-center justify-center rounded-lg px-5 text-center text-sm font-semibold tracking-tight shadow-card transition-all duration-200 ease-in-out hover:brightness-95 hover:shadow-card-hover active:translate-y-px disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400 focus-visible:ring-offset-2`}
    >
      {loading ? (
        <Loader color={loaderColor} />
      ) : (
        <span className={`${textColor} inline-flex items-center gap-2`}>
          {icon && <FontAwesomeIcon icon={icon} />}
          {text}
        </span>
      )}
    </button>
  );
}

export default Button;
